import { Button, Chip, Grid, Typography } from '@mui/material';
import { apiPost, AppState, DrivePDFMimeType, ProjectDataAttrs, projectDataSelector, projectDataSlice, projectSelector, selectGroupsFromProjectData, selectNiveauxFromProjectData, selectouverturesFromProjectData, selectZonesFromProjectData } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { appStore } from '../../store';
import { Editor } from '../editor/Editor';
import { GoogleFileFolderSelector, GoogleFinderMode } from '../googledrive/GoggleFileSystem';

export const ProjectQuicaillerie = () => {

    const params = useParams();
    const projectId = params.id ?? '0';

    const [updloadFile, setUploadFile] = React.useState<File | undefined>();

    const project = useSelector((state: AppState) => projectSelector.selectById(state, projectId));
    const projectData = useSelector((state: AppState) => projectDataSelector.selectById(state, projectId));
    const ouvertures = useSelector((state: AppState) => selectouverturesFromProjectData(state, projectId));
    const groupes = useSelector((state: AppState) => selectGroupsFromProjectData(state, projectId));
    const niveaux = useSelector((state: AppState) => selectNiveauxFromProjectData(state, projectId));
    const zones = useSelector((state: AppState) => selectZonesFromProjectData(state, projectId));

    const [selectGoogleFile, setSelectGoogleFile] = React.useState(false);

    React.useEffect(() => {
        if (updloadFile) {
            uploadProjectDataFile();
        }
    }, [updloadFile]);

    const uploadProjectDataFile = async () => {
        if (project && updloadFile) {
            const data = new FormData();

            data.append('files', updloadFile);
            const xhr = new XMLHttpRequest();
            const response: any | ProjectDataAttrs = await new Promise((resolve) => {
                xhr.upload.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {
                        console.log("upload progress:", event.loaded / event.total);
                    }
                });
                xhr.addEventListener("progress", (event) => {
                    if (event.lengthComputable) {

                    }
                });
                xhr.addEventListener("loadend", () => {
                    resolve(xhr.readyState === 4 && xhr.status === 200 ? JSON.parse(xhr.response) : 'Erreur');
                    setUploadFile(undefined);
                });
                xhr.open("POST", '/project/' + project.id + '/uploadprojectbordereauquicaillerie', true);
                xhr.send(data);
            });
            if ('id' in response) {
                appStore.dispatch(projectDataSlice.actions.upsertOne(response as ProjectDataAttrs));
            } else if ('error' in response) {
                alert(response.error);
            } else {
                alert('Impossible de télécharger');
            }
            console.log('response', response);
        }
    };

    if (project && projectData) {

        return <Grid container spacing={2}>
            <Grid item xs={12}>
                <Editor />
            </Grid>
            <Grid item xs={12}>
                <Typography component='span' m={2}>Ouvertures : <Chip label={ouvertures.length} /></Typography>
                <Typography component='span' m={2}>Groupes : <Chip label={groupes.length} /></Typography>
                <Typography component='span' m={2}>Niveaux : <Chip label={niveaux.length} /></Typography>
                {zones.length > 1 && <Typography component='span' m={2}>Zones : <Chip label={zones.length} /></Typography>}
            </Grid>
            <Grid xs={12}>
                <Button onClick={() => { setSelectGoogleFile(true); }}>Sélectionner le document Excel dans Google Drive</Button>
                <input
                    accept={DrivePDFMimeType}
                    style={{ display: 'none' }}
                    id="raised-button-file"
                    multiple
                    type="file"
                    onChange={(event) => setUploadFile(event.target.files?.[0])}
                />
                <label htmlFor="raised-button-file">
                    <Button variant="contained" component="span">
                        Téléverser
                    </Button>
                </label>
                {selectGoogleFile && <GoogleFileFolderSelector onFileSelected={async file => {
                    console.log('file', file);
                    if (file) {
                        const response = await apiPost('projectSetDataFromGoogleDriveFile', { projectId: project.id, driveFileId: file.id });
                        appStore.dispatch(projectDataSlice.actions.upsertOne(response));
                        console.log('response', response);
                    }
                    setSelectGoogleFile(false);

                }} mode={GoogleFinderMode.SELECT_PDF} />}
            </Grid>
        </Grid>;
    } else return <><Editor /></>;
};
